module.exports = __webpack_public_path__ + "img/cjrh.b6308ae2.png";